<template>
    <div class="conInfos">
        <div class="conInfos_title">
            <div class="conInfos_title_left">
                <span style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;border-left: 3px solid var(--subjectColor);">人事合同</span>
            </div>
            <div class="conInfos_title_right">
                <el-button v-if="canEdit && !isMypersonalRecords" size="mini" @click="addconInfos">添加</el-button>
            </div>
        </div>
        <el-table :data="vo.passenger.conInfos" border="1px" style="width: 100%" class="conInfosList">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="name" label="员工姓名" align="center" width="120px">
                <template slot-scope="scope">
                    <form-item
                        ref="name"
                        :field="{ defaultValue: null, elementCanEdit: '0', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'input', emptyMessage: '', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '员工姓名', propName: 'name', propType: 'String', textFormatter: 'textfield', valueMaxLength: 50, valueMinLength: null, model: 'scope.row.name', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit && !isMypersonalRecords"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="conName" label="合同名称" align="center">
                <template slot-scope="scope">
                    <form-item
                        ref="conName"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入合同名称', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '合同名称', propName: 'conName', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.conName', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit && !isMypersonalRecords"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="conCode" label="合同编号" align="center" width="150px">
                <template slot-scope="scope">
                    <form-item
                        ref="conCode"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入合同编号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '合同编号', propName: 'conCode', propType: 'String', textFormatter: 'textfield', valueMaxLength: 100, valueMinLength: null, model: 'scope.row.conCode', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit && !isMypersonalRecords"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="conStartDate" label="合同开始日期" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="conStartDate"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: 'format：yyyy年MM月dd日', elementReadonly: 1, elementType: 'date', emptyMessage: '请输入现合同起始日', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '合同开始日期', propName: 'conStartDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, model: 'scope.row.conStartDate', option: [], weekday: 0 }"
                        :vo="scope.row"
                        :can-edit="canEdit && !isMypersonalRecords"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="conEndDate" label="合同结束日期" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="conEndDate"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: 'format：yyyy年MM月dd日', elementReadonly: 1, elementType: 'date', emptyMessage: '请输入现合同到期日', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '合同结束日期', propName: 'conEndDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, model: 'scope.row.conEndDate', option: [], weekday: 0 }"
                        :vo="scope.row"
                        :can-edit="canEdit && !isMypersonalRecords"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="fileName" label="附件" align="center" width="150px">
                <template slot-scope="scope">
                    <!-- 附件上传 -->
                    <div v-if="canEdit && !isMypersonalRecords" style="text-align: center" @click="uploadChange(scope.row)">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="附件" style="display: flex; align-items: center; justify-content: center">
                            <div v-if="scope.row.fileName" class="attachment-link-wrapper">
                                <el-link :title="scope.row.fileName" class="attachment-link" @click="download(scope.row)">
                                    {{ scope.row.fileName }}
                                </el-link>
                            </div>
                            <el-upload ref="uploadRef" style="min-width: 30px" class="upload-demo" action="#" :on-change="fileChange" :auto-upload="false" :on-remove="handleRemove" :multiple="false" :file-list="scope.row.passenger.attachments" :show-file-list="false">
                                <div style="color: #409eff">上传</div>
                            </el-upload>
                        </ValidationProvider>
                    </div>
                    <div v-else @click="uploadChange(scope.row)">
                        <div class="attachment-link-wrapper">
                            <el-link v-if="scope.row.fileName" :title="scope.row.fileName" class="attachment-link" @click="download(scope.row)">
                                {{ scope.row.fileName }}
                            </el-link>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="conMemo" label="备注" align="center">
                <template slot-scope="scope">
                    <form-item
                        ref="conMemo"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: 70, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入备注', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '备注', propName: 'conMemo', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.conMemo', option: [], autosize: false }"
                        :vo="scope.row"
                        :can-edit="canEdit && !isMypersonalRecords"
                    />
                </template>
            </el-table-column>
            <el-table-column v-if="canEdit && !isMypersonalRecords" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    name: 'ConInfos',
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        isMypersonalRecords: { type: Boolean, default: false },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        return {
            feeTypeRules
        }
    },
    data() {
        return {
            // 通用变量
            loginUser: this.$store.getters.loginUser,
            uploadRow: {},
            uploadAttachList: [] // 当前待上传附件列表
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {
        // 员工姓名读取当前数据
        if (this.vo.passenger.conInfos && this.vo.passenger.conInfos.length > 0) {
            this.vo.passenger.conInfos.forEach((item) => {
                item.name = this.vo.name
                if (!item.fileName && item.passenger.attachments.length > 0) {
                    item.fileName = item.passenger.attachments[0].fileName
                }
            })
        }
    },
    updated() {},
    methods: {
        timeFormat(val) {
            return val ? moment(new Date(val)).format('YYYY年MM月DD日') : ''
        },
        addconInfos() {
            this.$http({
                method: 'POST',
                url: '/rsgl/conInfo/addNew'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.vo.passenger.conInfos.push(res.body.vo)
                    if (res.body.vo) {
                        res.body.vo.name = this.vo.name
                    }
                }
            })
        },
        download(row) {
            window.open('apigw/rsgl/conInfo/download?id=' + row.id + '&dataField=conFile&nameField=fileName')
        },
        fileChange(files, fileList) {
            fileList[0] = files
            if (fileList.length > 0) {
                console.log(files, fileList)
                fileList[0].rowId = this.uploadRow.id
                this.vo.passenger.conInfos.forEach((item) => {
                    if (this.uploadRow.id === item.id) {
                        item.fileName = fileList[0].name
                    }
                })
                this.uploadAttachList.push(fileList[0])

                console.log(this.vo.passenger.conInfos, 'this.vo.passenger.conInfos')
                console.log(this.uploadAttachList, 'this.uploadAttachList')
            }
        },
        // 当前操作上传附件栏
        uploadChange(row) {
            this.uploadRow = row
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            this.vo.passenger.conInfos = this.vo.passenger.conInfos.filter((item) => item.id !== row.id)
        }
    }
}
</script>

<style scoped lang="scss">
.conInfos_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: #f2f5fb;
    // border: 1px solid #e3e8ee;
    // padding: 4px 6px !important;
    padding: 4px 6px 4px 0 !important;
    font-size: 14px;
    color: #333;
}
</style>
